<template>
    <div class="m-panel">
        <div class="m-panel-bar">
            <div class="m-panel-bar-title">
                {{ title }}
            </div>
        </div>
        <div class="m-panel-body">
            <Echart ref="option" :options="option" style="height: 100%"></Echart>
        </div>
    </div>
</template>
<script>
import echarts from 'echarts/lib/echarts';
import { postAction, putAction } from '@/api/manage';
export default {
    props: {
        titleImage: {
            type: String,
            default: ''
        },
    },
    data() {
        return {
            title: this.$t('各区域近一年用水分析'),
            option: {},
            url: {
                areaWaterUse: '/jeecg-charge/meter/waterAnalysis/areaWaterUseNew'
            },
            areaWaterUse: {

            }
        }
    },
    mounted() {

    },
    methods: {
        init() {
            this.$nextTick(() => {
                this.$refs.option.showLoading('default', {
                    maskColor: 'rgba(0,0,0,0.3)',
                    color: '#6ED9F2',
                    text: ''
                })
                this.resetData()
                this.queryAreaWaterUse()
            })
        },
        resetData() {
            this.option = this.$options.data.call(this).option
        },
        queryAreaWaterUse() {
            putAction(this.url.areaWaterUse, {}).then((res) => {
                if (res.success) {
                    this.areaWaterUse = res.result
                    this.setOption1()
                }
            })
        },
        setOption() {
            let seriesData = []
            let data = this.areaWaterUse.waterUseList
            let category = this.areaWaterUse.areaStrList
            let xAxisData = this.areaWaterUse.monthStrList
            for (let i = 0; i < data.length; i++) {
                seriesData.push({
                    name: category[i],
                    type: 'line',
                    smooth: true,
                    symbol: "circle",
                    showSymbol: false,
                    animationDelay: i * 100,
                    animationDuration: 2000,
                    data: data[i]
                })
            }
            this.$refs.option.hideLoading()
            this.option = {
                color: ['#FECA20', '#50E3C2', '#32C5FF', '#0091FF', '#0394FF', '#4634FA', '#0C2D82', '#B620E0', '#F7B500', '#FA6400', '#E02020'],
                title: {
                    show: false
                },
                tooltip: {
                    trigger: 'axis',
                    backgroundColor: 'rgba(0,11,42,0.9)',
                    borderColor: '#5D6A94',
                    borderWidth: 1,
                    borderRadius: 8,
                    textStyle: {
                        color: '#CEE2FF',
                    },
                    axisPointer: {
                        type: 'line',
                        lineStyle: {
                            color: '#019AF3'
                        }
                    }
                },
                legend: {
                    type: 'scroll',
                    data: category,
                    textStyle: {
                        color: '#CEE2FF'
                    },
                    icon: 'circle',
                    itemHeight: 10,
                    right: '5%',
                    pageIconColor: '#aaa',
                    pageIconInactiveColor: '#2f4554',
                    pageTextStyle: {
                        color: 'rgb(91, 135, 195)'
                    }
                },
                grid: {
                    left: '3%',
                    right: '2%',
                    bottom: '3%',
                    containLabel: true
                },
                xAxis: {
                    type: 'category',
                    boundaryGap: true,
                    data: xAxisData,
                    splitLine: {
                        show: false
                    },
                    axisTick: {
                        show: false
                    },
                    axisLine: {
                        show: true,
                        lineStyle: {
                            color: ['#074671'],
                        }
                    },
                    axisLabel: {
                        color: '#CEE2FF',
                        fontSize: 10
                    }
                },
                yAxis: {
                    type: 'value',
                    min: 0,
                    name: this.$t('用量(m³)'),
                    nameTextStyle: {
                        color: '#CEE2FF',
                        // /align: 'right'
                    },
                    splitLine: {
                        show: true,
                        lineStyle: {
                            type: 'dotted',
                            color: ['#074671'],
                        }
                    },
                    axisTick: {
                        show: false
                    },
                    axisLine: {
                        show: false
                    },
                    axisLabel: {
                        color: '#CEE2FF',
                        fontSize: 10
                    }
                },
                series: seriesData
            };
        },
        setOption1() {
            let xData = [];
            let seriesData = [];
            let yData = [];
            let yName = [];
            let areaInfoMap = this.areaWaterUse.areaInfoMap;
            for (const key in areaInfoMap) {
                yName.push(areaInfoMap[key]);
            }
            let areaWaterUseMap = this.areaWaterUse.areaWaterUseMap;
            for (const key in areaWaterUseMap) {
                xData.push(key);
                areaWaterUseMap[key].map((item,index)=>{
                    if(!yData[index]){
                        yData[index] = [];
                    }
                    yData[index].push(item);
                })
            }
            yData.map((item,index)=>{
                seriesData.push({
                    name: yName[index],
                    type: 'bar',
                    stack: 'total',
                    barWidth: '60%',
                    smooth: true,
                    symbol: "none",
                    animationDelay: (index*200)-100,
                    animationDuration: 300,
                    data: item
                })
            })
            this.$refs.option.hideLoading()
            this.option = {
                // color: ['#FECA20', '#50E3C2', '#32C5FF', '#0091FF', '#0394FF', '#4634FA', '#0C2D82', '#B620E0', '#F7B500', '#FA6400', '#E02020'],
                tooltip: {
                    trigger: 'axis',
                    backgroundColor: 'rgba(0,11,42,0.9)',
                    borderColor: '#5D6A94',
                    borderWidth: 1,
                    borderRadius: 8,
                    textStyle: {
                        color: '#CEE2FF',
                    },
                    axisPointer: {
                        type: 'line',
                        lineStyle: {
                            color: '#019AF3'
                        }
                    }
                },
                legend: {
                    type: 'scroll',
                    data: yName,
                    textStyle: {
                        color: '#CEE2FF'
                    },
                    icon: 'circle',
                    itemHeight: 10,
                    left: 'left',
                    pageIconColor: '#aaa',
                    pageIconInactiveColor: '#2f4554',
                    pageTextStyle: {
                        color: 'rgb(91, 135, 195)'
                    }
                },
                grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '3%',
                    containLabel: true
                },
                yAxis: {
                    type: 'value',
                    splitLine: {
                        show: true,
                        lineStyle: {
                            type: 'dotted',
                            color: ['#074671'],
                        }
                    },
                    axisTick:{
                        show: false
                    },
                    axisLine: {
                        show: false
                    },
                    axisLabel: {
                        color: '#D1F3FF',
                        fontSize: 10
                    }
                },
                xAxis: {
                    type: 'category',
                    data: xData,
                    boundaryGap: true,
                    splitLine: {
                        show: false
                    },
                    axisTick:{
                        show: false
                    },
                    axisLine: {
                        show: true,
                        lineStyle: {
                            color: ['#074671'],
                        }
                    },
                    axisLabel: {
                        color: '#D1F3FF',
                        fontSize: 10
                    }
                },
                series: seriesData
            };
        }

    }
}
</script>